import { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { actualizarDepartamento, getOneDepartamento } from "../../../services/departamento.service";
import { getAllPaises } from "../../../services/pais.service";
import { ContenedorPageTemplate } from "../../../components/templates/ContenedorPageTemplate";
import { showAlert, showErrorAlert } from "../../../components/molecules/ShowAlert";

const buttonStyle = {
  padding: "10px 20px",
  color: "#fff",
  border: "none",
  borderRadius: "5px",
  cursor: "pointer",
};

const saveButtonStyle = {
  ...buttonStyle,
  backgroundColor: "#4CAF50",
};

const cancelButtonStyle = {
  ...buttonStyle,
  backgroundColor: "#f44336",
};

export const ActualizarDepartamentoPage = () => {
  const { idDepartamento } = useParams();
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    idDepartamento: "",
    nombre: "",
    idPais: "",
  });
  const [paises, setPaises] = useState([]);
  const [cargandoPaises, setCargandoPaises] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [dataDepartamento, paisesData] = await Promise.all([
          getOneDepartamento(idDepartamento),
          getAllPaises().catch(() => []),
        ]);

        setPaises(paisesData || []);
        setFormData({
          idDepartamento: dataDepartamento.idDepartamento,
          nombre: dataDepartamento.nombre,
          idPais: dataDepartamento.idPais,
        });
      } catch (err) {
        setError("No se pudieron cargar los datos. Por favor, verifica el servidor.");
        console.error(err);
      } finally {
        setCargandoPaises(false);
      }
    };
    fetchData();
  }, [idDepartamento]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      await actualizarDepartamento(formData.idDepartamento, {
        nombre: formData.nombre,
        idPais: formData.idPais,
      });

      showAlert({
        title: "¡Actualizado correctamente!",
        text: "Los datos del departamento han sido actualizados correctamente.",
        callback: () => {
          navigate("/departamento");
        },
      });
    } catch (err) {
      if (err.response && err.response.data?.message) {
        showErrorAlert({ text: err.response.data.message });
      } else if (err.response && err.response.data?.errors) {
        const mensajes = Object.values(err.response.data.errors).flat();
        showErrorAlert({ text: "Errores de validación:\n" + mensajes.join("\n") });
      } else {
        showErrorAlert({ text: "Ocurrió un error inesperado." });
      }
    }
  };

  if (error) {
    return <p style={{ color: "red" }}>{error}</p>;
  }

  const handleCancel = () => {
    navigate("/departamento");
  };

  return (
    <ContenedorPageTemplate titulo={`Actualizar datos del Departamento`}>
      <form
        onSubmit={handleSubmit}
        style={{
          maxWidth: "600px",
          margin: "0 auto",
          padding: "20px",
          background: "#f9f9f9",
          borderRadius: "8px",
          boxShadow: "0 0 10px rgba(0, 0, 0, 0.1)",
        }}
      >
        <div style={{ marginBottom: "15px" }}>
          <label style={{ display: "block", marginBottom: "5px", fontWeight: "bold" }}>
            Nombre del Departamento:
          </label>
          <input
            type="text"
            name="nombre"
            value={formData.nombre}
            onChange={handleChange}
            required
            maxLength={60}
            style={{
              width: "100%",
              padding: "10px",
              borderRadius: "5px",
              border: "1px solid #ccc",
            }}
          />
        </div>

        <div style={{ marginBottom: "15px" }}>
          <label style={{ display: "block", marginBottom: "5px", fontWeight: "bold" }}>
            País:
          </label>
          {cargandoPaises ? (
            <div style={{ padding: "10px", color: "#666" }}>Cargando países...</div>
          ) : (
            <select
              name="idPais"
              value={formData.idPais}
              onChange={handleChange}
              required
              style={{
                width: "100%",
                padding: "10px",
                borderRadius: "5px",
                border: "1px solid #ccc",
              }}
            >
              <option value="">Seleccione un país</option>
              {paises.map((pais) => (
                <option key={pais.idPais} value={pais.idPais}>
                  {pais.nombre}
                </option>
              ))}
            </select>
          )}
        </div>

        <div style={{ display: "flex", justifyContent: "space-between", gap: "10px" }}>
          <button type="submit" style={saveButtonStyle}>
            Guardar cambios
          </button>
          <button type="button" style={cancelButtonStyle} onClick={handleCancel}>
            Cancelar
          </button>
        </div>
      </form>
    </ContenedorPageTemplate>
  );
};